import script from "./NavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBar.vue?vue&type=script&setup=true&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=46f955ae&scoped=true&lang=css"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46f955ae"]])

export default __exports__